import React, { useState } from 'react'
import { createStyles, makeStyles, Typography } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import Button from '../Button/Button'
import CMSText from '../Global/CMSText'
import GlobalModal from '../Global/GlobalModal'
import Loader from '../Loader/Loader'
import { useThrottle } from '../../hooks/useThrottle'

const useStyles = makeStyles((theme) =>
  createStyles({
    downloadlink: {
      textDecoration: 'underline',
    },
    hide: {
      opacity: 0,
      transition: theme.transitions.create('opacity'),
    },
    show: {
      opacity: 1,
      transition: theme.transitions.create('opacity'),
    },
    modalButtonsContainer: {
      display: 'flex',
      marginTop: '1rem',
      justifyContent: 'center',
    },
    modalButton: {
      '&:nth-child(2)': {
        marginLeft: '2rem',
      },
    },
    messageContainer: {
      display: 'flex',
      alignItems: 'center',
      '&>span': {
        marginLeft: '2rem',
      },
    },
  })
)

type Tprops = {
  downloadLink: string
  t: any
  prismicData?: any
  isDisabled: boolean
  isDownloadLoading: boolean
  text: string | React.ReactElement
  onValidate: () => void
}

const ReturnVoucherButton = ({
  downloadLink,
  t,
  prismicData,
  isDisabled,
  isDownloadLoading,
  text,
  onValidate: onValidateAction,
}: Tprops) => {
  const classes = useStyles()
  const [openModal, setOpenModal] = useState(false)

  const hasDownloadLink = downloadLink !== ''

  const onValidate = useThrottle(onValidateAction, 1500)

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  return hasDownloadLink ? (
    <Typography variant={'h4'}>
      <a href={downloadLink} target={'blank'} className={classes.downloadlink}>
        <CMSText
          data={[]}
          defaultText={t('texts:subscription_order:link_download_return')}
        />
      </a>
    </Typography>
  ) : (
    <>
      <Button
        data-testid={'downloadBtn'}
        variant={'outlined'}
        color={'secondary'}
        size={'small'}
        disabled={isDisabled}
        onClick={() => setOpenModal(true)}
      >
        <span className={isDownloadLoading ? classes.hide : classes.show}>
          {text}
        </span>
        {isDownloadLoading && <Loader />}
      </Button>
      <GlobalModal
        open={openModal}
        onClose={handleCloseModal}
        modalTitle={{
          data: prismicData?.return_voucher_modal_title,
          defaultText: t('texts:confirmation:generate_vouchers'),
        }}
      >
        <>
          <div className={classes.messageContainer}>
            <InfoIcon color="error" fontSize="large" />
            <span>
              <CMSText
                data={prismicData?.return_voucher_modal_message}
                defaultText={t(
                  'texts:confirmation:voucher_confirmation_message'
                )}
              />
            </span>
          </div>
          <div className={classes.modalButtonsContainer}>
            <Button onClick={handleCloseModal} className={classes.modalButton}>
              <CMSText
                data={prismicData?.return_voucher_modal_cancel}
                defaultText={t('texts:confirmation:cancel')}
              />
            </Button>
            <Button
              onClick={onValidate}
              variant={'contained'}
              color={'secondary'}
              className={classes.modalButton}
            >
              <CMSText
                data={prismicData?.return_voucher_modal_confirm}
                defaultText={t('texts:confirmation:confirm')}
              />
            </Button>
          </div>
        </>
      </GlobalModal>
    </>
  )
}

export default ReturnVoucherButton
